<template>
  <el-dialog ref="dialog" title="数据操作" size="large" style="min-width:1280px">
    <div class="m-b-10" v-loading="loading">
      <el-button class="fl m-r-20" type="primary" @click="addCudConfig">添加操作</el-button>
      <div class="fl form-tips lh-20" style="width:80%">日期变量说明：Y代表年，M代表月，D代表天，H代表时，I代表分，S代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，H+1代表一个小时后，I+10代表十分钟后，S+30代表30秒后</div>
      <div style="clear:both"></div>
    </div>
    <div class="input-list bor-deep-gra ovf-auto m-b-10" style="height:500px">
      <!-- 每个操作 -->
      <div v-for="(item, index) in childCudConfig">
        <div class="bor-b-gray m-b-10">
          <div class="inline-block m-r-10 m-b-10">
            <el-button type="primary" size="small" @click="sortUp(index)" :disabled="index == 0">上移</el-button>
            <el-button type="primary" size="small" @click="sortDown(index)" :disabled="index == childCudConfig.length - 1">下移</el-button>
            <el-button size="small" @click="deleteCudConfig(index)">删除</el-button>
          </div>
          <div class=" inline-block m-l-20">
            <span>操作类型</span>
            <el-select v-model="item.deal_type" placeholder="请选择操作类型" @change="dealTypeChange(item)">
              <el-option v-for="option in dealTypeOptions" :label="option.name" :value="option.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="m-b-10" v-if="showFuncSelect(item)">
          <div>
            <span>函数库</span>
            <el-select v-model="item.function_name" placeholder="请选择函数库" @change="funcChange(item, index)">
              <el-option v-for="option in functions" :label="option.title" :value="option.name"></el-option>
            </el-select>
          </div>
        </div>
        <div class="m-b-10" v-if="showTargetForm(item)">
          <div>
            <span>模板表单</span>
            <el-select v-model="item.template_model_id" placeholder="请选择操作表单" @change="templateModelChange(item)">
              <el-option v-for="option in models" :label="option.title + '(' + option.name + ')'" :value="option.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="m-b-10" v-if="!showFuncSelect(item)">
          <div>
            <span v-if="showTargetForm(item)">目标表单</span>
            <span v-else>操作表单</span>
            <el-select v-model="item.model_id" placeholder="请选择操作表单" @change="modelChange(item, index)">
              <el-option v-for="option in models" :label="option.title + '(' + option.name + ')'" :value="option.id"></el-option>
            </el-select>
          </div>
        </div>
        <!-- 分离组件 执行前提  -->
          <condition-config
          :currentItem="item"
          :loadings="loadings"
          :currentIndex="index"
          :logicOptions="logicOptions"
          :paramTypeOptions="paramTypeOptions"
          :fieldByModelId="fieldByModelId"
          :flowFormField="flowFormField"
          :currentType="CUD_LIST_PROEXEC">
        </condition-config> 
        <!-- 分离组件 执行前提  -->
        <!-- 分离组件 筛选条件  -->
         <div v-if="showWhereList(item)"> 
          <condition-config
            :currentItem="item"
            :loadings="loadings"
            :currentIndex="index"
            :logicOptions="logicOptions"
            :paramTypeOptions="paramTypeOptions"
            :fieldByModelId="fieldByModelId"
            :flowFormField="flowFormField"
            :currentType="CUD_LIST_WHERE">
          </condition-config>
         </div> 
        <!-- 分离组件 筛选条件  -->
        <!-- 更新内容列表 -->
        <div class="m-b-10" v-if="showFieldList(item)">
          <div v-if="typeCopy(item)">目标数据</div>
          <div v-else>更新内容</div>
          <el-table
            v-loading="loadings[index]"
            :data="item.field"
            style="width: 100%">
            <el-table-column
              label="传入类型"
              width="250">
              <template scope="scope">
                <el-select class="w-200" v-model="scope.row.param_type">
                  <el-option v-for="(option,optionIndex) in paramTypeOptions"
                             :label="option.name"
                             :value="option.id"
                             v-if="showParamTypeOptions(item.deal_type, optionIndex)">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="传入的字段或参数">
              <template scope="scope">
                <el-input class="w-200" v-model="scope.row.param" v-if="isText(scope.row)"></el-input>
                <el-select class="w-200" v-model="scope.row.param" v-else-if="isSelect(scope.row) && !isTemplateForm(scope.row) && item.deal_type != CUD_DEAL_FUNC">
                  <el-option v-for="option in flowFormField"
                             :label="option.name + '(' + option.title + ')'"
                             :value="option.field_id">
                  </el-option>
                </el-select>
                <!-- 执行函数 -->
                <el-select class="w-200" v-model="scope.row.param" v-else-if="isSelect(scope.row) && !isTemplateForm(scope.row) && item.deal_type == CUD_DEAL_FUNC" @change="getForeignKey(scope.row, scope.$index, index)">
                  <el-option v-for="option in flowFormField"
                             :label="option.name + '(' + option.title + ')'"
                             :value="option.field_id">
                  </el-option>
                </el-select>
                <el-select class="w-200" v-model="scope.row.param" v-else-if="isSelect(scope.row) && isTemplateForm(scope.row)">
                  <el-option v-for="option in fieldByModelId[item.template_model_id]"
                             :label="option.name + '(' + option.title + ')'"
                             :value="option.field_id">
                  </el-option>
                </el-select>
                <span v-if="scope.row.param_type == CUD_PARAM_CUMULATIVE_VARIABLE">*</span>
                 <el-input v-if="scope.row.param_type == CUD_PARAM_CUMULATIVE_VARIABLE" type="number" class="w-200" v-model.number="scope.row.coefficient"></el-input>
              </template>
            </el-table-column>

            <el-table-column
                v-if="item.deal_type == CUD_DEAL_FUNC"
                label="外键关联表的字段">
                <template scope="scope">
                  <el-cascader
                    v-if="scope.row.foreign_key_list && scope.row.foreign_key_list.length>0"
                    placeholder="外键关联字段"
                    v-model="scope.row.form_key_sign"
                    :options="scope.row.foreign_key_list"
                    filterable
                    change-on-select
                    @change="changeForeign"
                  ></el-cascader>
                  <el-input class="w-200" :disabled="true" v-else></el-input>
                </template>
              </el-table-column>

            <el-table-column
              label="对应字段">
              <template scope="scope">
                <span class="fz-12" 
                      :class="{
                        'form-tips': fieldByModelId[item.model_id] &&
                                     fieldByModelId[item.model_id][scope.$index] &&
                                     fieldByModelId[item.model_id][scope.$index].is_needed == 1
                      }" 
                      v-if="fieldByModelId[item.model_id] &&
                      fieldByModelId[item.model_id][scope.$index] &&
                      (item.deal_type == CUD_DEAL_ADD || item.deal_type == CUD_DEAL_COPY)">
                      {{ fieldByModelId[item.model_id][scope.$index].name }}({{ fieldByModelId[item.model_id][scope.$index].title }})
                </span>
                <span v-if="item.deal_type == CUD_DEAL_FUNC">
                  {{ scope.row.field_id }}
                </span>
                <el-select v-model="scope.row.field_id" v-if="item.deal_type == CUD_DEAL_UPDATE || item.deal_type == CUD_DEAL_DELETE">
                  <el-option v-for="option in fieldByModelId[item.model_id]"
                             :label="option.name + '(' + option.title + ')'"
                             :value="option.field_id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="180"
              v-if="item.deal_type == CUD_DEAL_UPDATE || item.deal_type == CUD_DEAL_DELETE">
              <template scope="scope">
                <el-button size="small" @click="deleteField(item.field, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="tx-c m-t-10" v-show="item.deal_type == CUD_DEAL_UPDATE || item.deal_type == CUD_DEAL_DELETE">
            <el-button type="primary" @click="addField(item.field, 'field')">添加</el-button>
          </div>
        </div>
        <!-- 更新内容列表 -->
      </div>
      <!-- 每个操作 -->
    </div>
    <span slot="footer" class="fl dialog-footer m-b-10">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="save">保存所有修改</el-button>
    </span>
  </el-dialog>
</template>

<script>
  /**
   * @author duoremix
   * @param Object cudConfig cud配置
   * @param Number modelId 绑定表单id
   */
  import http from '../../../assets/js/http'
  import flowConfig from '../../../config/flowConfig'
  import conditionConfig from './conditionConfig'
  export default {
    props: {
      cudConfig: {
        type: Array,
        default() {
          return []
        }
      },
      modelId: {
        type: Number,
        default() {
          return -1
        }
      }
    },
    data() {
      return {
        cudConfigModel: {  // 操作配置数据结构
          deal_type: 10,
          field: [],
          function_name: '',  // 函数名称
          model_id: null,
          package_name: '', // 包名
          pre_exec: [], // 执行前提条件
          pre_exec_logic_relation: '',
          pre_exec_logic_exec_result: false,
          where: [],
          logic_exec_result: false, // 条件逻辑执行结果
          logic_relation: '', // 条件逻辑关系
          this_model_id: '',    // 本表表单id
          template_model_id: '' // 模板表单id
        },
        fieldModel: { // 控件配置数据结构
          field_id: '', // 字段id
          param: '',      // 参数值
          param_type: 10,  // 参数类型
          coefficient: 1, // 系数
          form_key_sign: [],
          form_key_config: [],
          foreign_key_list: []
        },
        dealTypeOptions: [  // 操作类型数组
          { id: 10, name: '添加' },
          { id: 20, name: '更新' },
          { id: 30, name: '删除' },
          { id: 40, name: '执行函数' },
          { id: 50, name: '复制数据' }
        ],
        paramTypeOptions: [ // 参数类型数组
          { id: 10, name: '常量', disabled: false },
          { id: 20, name: '本表字段', disabled: false },
          { id: 30, name: '日期变量', disabled: false },
          { id: 40, name: '不传值', disabled: false },
          { id: 60, name: '累加常量', disabled: false },
          { id: 50, name: '累加变量', disabled: false },
          { id: 70, name: '累减变量', disabled: false },
          { id: 80, name: '模板表单字段', disabled: false }
        ],
        logicOptions: [ // 逻辑数组
          { id: 10, name: '大于' },
          { id: 20, name: '小于' },
          { id: 30, name: '等于' },
          { id: 40, name: '大于等于' },
          { id: 50, name: '小于等于' }
        ],
        models: [], // 表单列表
        functions: [], // 函数列表
        childCudConfig: [],  // 组件自己的配置
        fieldByMySelfList: {},
        fieldByModelId: {},  // 以表单id为索引的表单控件
        flowFormField: [],    // 流程绑定的表单的控件
        loading: false,
        loadings: [],
        itemChange: false,
        parentIndex: 0,
        filedIndex: 0
      }
    },
    async created() {
      this.init()
      this.models = await this.getModels()
      this.functions = await this.getFuncs()
      if (this.modelId) {
        this.flowFormField = await this.getFields(this.modelId)
        this.flowFormField.push({
          name: 'id',
          title: '主键',
          field_id: 'id',
          isPrimary: true
        })
      }
    },
    methods: {
      init() {
        this.loading = true
        _(this.cudConfig).forEach(async (item) => {
          await this.checkModelField(item)
          this.loadings.push(false)
        })
        this.childCudConfig = _.cloneDeep(this.cudConfig)
        this.loading = false
      },
      showFieldList(item) {  // 显示更新内容列表
        return item.deal_type == this.CUD_DEAL_ADD ||
               item.deal_type == this.CUD_DEAL_UPDATE ||
               item.deal_type == this.CUD_DEAL_FUNC ||
               item.deal_type == this.CUD_DEAL_COPY
      },
      showWhereList(item) {  // 显示筛选条件列表
        return item.deal_type == this.CUD_DEAL_UPDATE ||
               item.deal_type == this.CUD_DEAL_DELETE ||
               item.deal_type == this.CUD_DEAL_COPY
      },
      showFuncSelect(item) {  // 显示执行函数列表
        return item.deal_type == this.CUD_DEAL_FUNC
      },
      showTargetForm(item) {  // 显示目标表单
        return item.deal_type == this.CUD_DEAL_COPY
      },
      typeCopy(item) {  // 复制类型
        return item.deal_type == this.CUD_DEAL_COPY
      },
      isText(item) {  // 输入框
        return item.param_type == this.CUD_PARAM_CONST || // 常量
               item.param_type == this.CUD_PARAM_DATE || // 日期变量
               item.param_type == this.CUD_PARAM_CUMULATIVE_CONSTANT     // 累加常量
      },
      isSelect(item) { // 下拉框
        return item.param_type == this.CUD_PARAM_FORMVALUE ||
               item.param_type == this.CUD_PARAM_CUMULATIVE_VARIABLE || // 累加变量
               item.param_type == this.CUD_PARAM__SUBTRACT_VARIABLE ||
               item.param_type == this.CUD_PARAM_TEMPLATE
      },
      isTemplateForm(item) {  // 模板表单字段
        return item.param_type == this.CUD_PARAM_TEMPLATE
      },
      async getModels() { // 获取所有表单
        let res = await this.apiGet('form/models')
        let arr = []
        let data = this.promiseHandler(arr, res)
        return data.list
      },
      async checkModelField(item) {
        let id = null
        if (item.model_id && !this.fieldByModelId[item.model_id]) {
          id = item.model_id
        }
        if (id) {
          let newField = await this.getFields(id)
          newField.push({
            name: 'id',
            title: '主键',
            field_id: 'id',
            isPrimary: true
          })
          this.$set(this.fieldByModelId, id, newField)
        }
        if (item.template_model_id && !this.fieldByModelId[item.template_model_id]) {
          id = item.template_model_id
        }
        if (id) {
          let newField = await this.getFields(id)
          newField.push({
            name: 'id',
            title: '主键',
            field_id: 'id',
            isPrimary: true
          })
          this.$set(this.fieldByModelId, id, newField)
        }
        if (!item.pre_exec) {
          item.pre_exec = []
        }
      },
      async getFields(id) { // 获取表单的控件
        let postData = {
          params: {
            type: 1
          }
        }
        let res = await this.apiGet(`form/models/${id}/fields`, postData)
        let arr = []
        return this.promiseHandler(arr, res)
      },
      async getFuncs() {
        let res = await this.apiGet('cms/contents/functions')
        let data = this.promiseHandler(data, res)
        let functions = []
        _(data).forEach((item) => {
          _(item.functions).forEach((func) => {
            functions.push({
              name: func.name,  // 函数名
              param: func.param,  // 函数参数
              return_param: func.return_param,  // 函数返回参数
              title: func.title,  // 函数中文名
              package_name: item.pakege_name,  // 包名
              package_title: item.title   // 包中文名
            })
          })
        })
        return functions
      },
      addCudConfig() { // 添加配置
        let newObj = _.cloneDeep(this.cudConfigModel)
        newObj.this_model_id = this.modelId
        this.childCudConfig.push(newObj)
      },
      deleteCudConfig(index) { // 删除配置
        this.childCudConfig.splice(index, 1)
      },
      openDialog() {
        this.childCudConfig = _.cloneDeep(this.cudConfig)
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      sortUp(index) { // 上移
        let temp = this.childCudConfig[index]
        this.childCudConfig.splice(index, 1)
        this.childCudConfig.splice(index - 1, 0, temp)
      },
      sortDown(index) { // 下移
        let temp = this.childCudConfig[index]
        this.childCudConfig.splice(index, 1)
        this.childCudConfig.splice(index + 1, 0, temp)
      },
      addField(item, type) {  // 添加参数
        if (type == 'where') { // 筛选条件
          item.push(_.cloneDeep(this.whereModel))
        } else {  // 更新内容
          item.push(_.cloneDeep(this.fieldModel))
        }
      },
      deleteField(item, index) { // 删除参数
        item.splice(index, 1)
      },
      funcChange(item, index) { // 所选函数变化
        _(this.functions).forEach((res) => {
          if (res.name == item.function_name) {
            item.package_name = res.package_name
            return false
          }
        })
        this.setField(item, false) // 设置参数
      },
      async modelChange(item, index) { // 所选表单变化
        this.loadings[index] = true
        await this.checkModelField(item)
        this.setField(item, false) // 设置参数
        this.loadings[index] = false
      },
      dealTypeChange(item) {  // 操作类型变化
        if (this.itemChange) {
          return
        }
        item.template_model_id = ''
        this.setField(item, true)
      },
      setField(item, isReset) {  // 设置参数
        let dealType = item.deal_type
        if (isReset) {
          // item.field = []
          // item.where = []
          item.field.splice(0, item.field.length)
          item.where.splice(0, item.where.length)
          item.pre_exec.splice(0, item.pre_exec.length)
        }
        if (dealType == this.CUD_DEAL_ADD ||
            dealType == this.CUD_DEAL_COPY) {  // 如果是添加或复制操作
          if (dealType == this.CUD_DEAL_ADD) {
            item.where.splice(0, item.where.length)
          }
          item.field.splice(0, item.field.length)
          item.pre_exec.splice(0, item.pre_exec.length)
          if (item.model_id && this.fieldByModelId[item.model_id]) {
            _(this.fieldByModelId[item.model_id]).forEach((res) => {
              let field = _.cloneDeep(this.fieldModel)
              field.field_id = res.field_id
              item.field.push(field)
            })
          }
        } else if (dealType == this.CUD_DEAL_FUNC) { // 如果是执行函数
          item.field.splice(0, item.field.length)
          item.where.splice(0, item.where.length)
          item.pre_exec.splice(0, item.pre_exec.length)
          let currentFunction = null
          _(this.functions).forEach((res) => {
            if (res.name == item.function_name) {
              currentFunction = res
              return false
            }
          })
          if (currentFunction) {
            _(currentFunction.param).forEach((res) => {
              let field = _.cloneDeep(this.fieldModel)
              field.field_id = res.name
              item.field.push(field)
            })
          }
        }
      },
      async templateModelChange(item) { // 模板表单切换
        await this.checkModelField(item)
        item.where.splice(0, item.where.length)
        item.pre_exec.splice(0, item.pre_exec.length)
      },
      showParamTypeOptions(type, index) {
        let arr = this.paramTypeOptions
        if (type === this.CUD_DEAL_UPDATE) {
          if (index === 3) {
            return false
          }
        } else {
          if (index === 4 || index === 5 || index === 6) {
            return false
          }
        }
        if (type != this.CUD_DEAL_COPY) {
          if (index === 7) {
            return false
          }
        }
        return true
      },
      save() {
        let noFillNeed = false
        let notCheck = false
        _(this.childCudConfig).forEach((res) => {
          // if (res.pre_exec_logic_exec_result === false) {
          //   notCheck = true
          //   return false
          // }
          // if (this.showWhereList(res) && res.logic_exec_result === false) {
          //   notCheck = true
          //   return false
          // }
          _(res.field).forEach((field, index) => {
            if (this.fieldByModelId[res.model_id] &&
                this.fieldByModelId[res.model_id][index] &&
                this.fieldByModelId[res.model_id][index].is_needed == 1 &&
                _g.isRealEmpty(field.param)) {  // 必填且为空
              noFillNeed = true
            }
          })
          if (noFillNeed) {
            return false
          }
        })
        if (noFillNeed) {
          _g.toastMsg(this, 'warning', '请填写必填字段')
          return
        }
        if (notCheck) {
          _g.toastMsg(this, 'warning', '请确保所有条件逻辑关系正确')
          return
        }
        this.$emit('setCudConfig', this.childCudConfig)
        setTimeout(() => {
          this.closeDialog()
        }, 200)
      },
      cancel() {
        this.closeDialog()
      },
      changeForeign(val) {
        this.childCudConfig[this.parentIndex].field[this.filedIndex].form_key_config = []
        if (val) {
          _(val).forEach((res) => {
            let arr = res.split('_')
            this.childCudConfig[this.parentIndex].field[this.filedIndex].form_key_config.push({
              form_key_field: arr[0],
              form_key_model: arr[1]
            })
          })
        }
      },
      async getForeignKey(row, index, parentIndex) {
        this.parentIndex = parentIndex
        this.filedIndex = index
        let data = []
        await this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
          if (res.code == 200) {
            data = res.data
          } else {
            _g.dealError(this, res)
          }
        })
        this.childCudConfig[parentIndex].field[index].foreign_key_list = []
        for (let i = 0; i < data.length; i++) {
          if (data[i].default.field_id == row.param) {
            if (data[i].default.type == 120) {
              if (data[i].key.form_model != '') {
                await this.apiGet(`cms/deals/fields/${data[i].key.form_model}/infinite`).then((res) => {
                  if (res.code == 200) {
                    this.childCudConfig[parentIndex].field[index].foreign_key_list = res.data
                  }
                })
              }
            }
          }
        }
      }
    },
    watch: {
      'cudConfig'() {
        this.itemChange = true
        this.init()
        setTimeout(() => {
          this.itemChange = false
        })
      },
      async 'modelId'() {
        if (this.modelId) {
          this.flowFormField = await this.getFields(this.modelId)
          this.flowFormField.push({
            name: 'id',
            title: '主键',
            field_id: 'id',
            isPrimary: true
          })
        }
      }
    },
    components: {
      conditionConfig
    },
    mixins: [http, flowConfig]
  }
</script>



// WEBPACK FOOTER //
// cudConfig.vue?156234ff